// extracted by mini-css-extract-plugin
export default {"container":"components-parity-tables-table-parity-strategy-issues-module__container"};